export default [
  // {
  //   path: '/calc',
  //   name: 'calc',
  //   meta: { title: "小小计算器" },
  //   component: () => import('@/views/base/calc.vue')
  // },
  {
    path: '/block',
    name: 'block',
    meta: { title: "代码块" },
    component: () => import('@/views/pages/block/index.vue')
  },
  {
    path: '/code',
    name: 'code',
    meta: { title: "编辑器" },
    component: () => import('@/views/pages/code/index.vue')
  },
  {
    path: '/cpp',
    name: 'cpp',
    meta: { title: "编辑器" },
    component: () => import('@/views/pages/code/cpp.vue')
  },
  {
    path: '/python',
    name: 'python',
    meta: { title: "编辑器" },
    component: () => import('@/views/pages/code/python.vue')
  },
  {
    path: '/share',
    name: 'share',
    meta: { title: "用户代码" },
    component: () => import('@/views/base/share.vue')
  },
  {
    path: '/apo',
    name: 'apo',
    meta: { title: "用户代码" },
    component: () => import('@/views/base/apo.vue')
  },
  // {
  //   path: '/tob',
  //   name: 'tob',
  //   meta: { title: "用户代码", description: "信息学奥赛,信奥课堂,少儿编程,星图熊,CSP", keywords: "信息学奥赛,信奥课堂,少儿编程,星图熊,CSP" },
  //   component: () => import('@/views/pages/home/tob.vue')
  // },
  {
    path: '/record',
    name: 'system',
    meta: { title: "用户代码" },
    component: () => import('@/views/base/record.vue')
  },
  {
    path: '/draw',
    name: 'draw',
    meta: { title: "画笔工具" },
    component: () => import('@/views/base/draw.vue')
  },
  {
    path: '/beike',
    name: 'beike',
    meta: { title: "课程列表" },
    component: () => import('@/views/base/beike.vue')
  },
  {
    path: '/urecord',
    name: 'system',
    meta: { title: "用户代码" },
    component: () => import('@/views/base/urecord.vue')
  },
  {
    path: '/scratch',
    name: 'scratch',
    meta: { title: "scratch" },
    component: () => import('@/views/pages/scratch/index.vue')
  },
  {
    path: '/diyMyCode',
    name: 'diyMyCode',
    meta: { title: "代码自定义" },
    component: () => import('@/views/base/diy_my_code.vue')
  },
  {
    path: '/registerCampus',
    name: 'registerCampus',
    meta: { title: "机构注册" },
    component: () => import('@/views/base/register_campus.vue')
  },
  {
    path: '/maintenance',
    name: 'maintenance',
    meta: { title: "系统升级中" },
    component: () => import('@/views/base/maintenance.vue')
  },
  {
    path: '/mindplus',
    name: 'mindplus',
    meta: { title: "mindplus" },
    component: () => import('@/views/pages/scratch/mindplus.vue')
  },
  {
    path: '/interface',
    name: 'interface',
    meta: { title: "interface" },
    component: () => import('@/views/base/interface.vue')
  },
  {
    path: '/upload',
    name: 'upload',
    meta: { title: "upload" },
    component: () => import('@/views/base/upload.vue')
  },
  {
    path: '/download',
    name: 'download',
    meta: { title: "download" },
    component: () => import('@/views/base/download.vue')
  },
  {
    path: '/rank/:contestID',
    name: 'rank',
    meta: { title: "rank" },
    component: () => import('@/views/base/rank.vue')
  },
  {
    path: '/rank/:contestID/:userID',
    name: 'grade',
    meta: { title: "用户成绩" },
    component: () => import('@/views/base/grade.vue')
  },
  {
    path: '/home',
    meta: {
      // requireAuth: true,
      title: "首页"
    },
    component: () => import('@/views/pages/home/home.vue'),
    // component: () => import('@/views/base/signin.vue'),
    // redirect: '/',
  },
  {
    path: '/',
    name: 'home',
    meta: { title: "首页" },
    component: () => import('@/views/pages/home/index.vue'),
    // component: () => import('@/views/base/signin.vue'),
  },
  {
    path: '/404',
    name: '404',
    meta: { title: "404" },
    component: () => import('@/views/base/404.vue')
  },
  {
    path: '*',
    meta: { title: "404" },
    component: () => import('@/views/base/404.vue')
  },
  {
    path: '/signin',
    name: 'signin',
    meta: { title: "登录" },
    component: () => import('@/views/base/signin.vue')
  },
  {
    path: '/signup',
    name: 'signup',
    meta: { title: "注册" },
    component: () => import('@/views/base/signup.vue')
  },
  {
    path: '/forgetpassword',
    name: 'forgetPassword',
    meta: { title: "忘记密码" },
    component: () => import('@/views/base/forgetpassword.vue')
  },
  {
    path: '/share/:id',
    name: 'share',
    meta: { title: "分享" },
    component: () => import('@/views/pages/share/index.vue')
  },
  {
    path: '/studyrep/:courseID',
    name: 'studyrep',
    meta: { title: "分享" },
    component: () => import('@/views/pages/share/index.vue')
  },
  {
    path: '/code/:id',
    name: 'code',
    meta: { title: "分享代码" },
    component: () => import('@/views/base/code.vue')
  },
  {
    path: '/teachcode/user/:codeID',
    name: 'user',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },
  {
    path: '/teachcode/system/:codeID',
    name: 'system',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },


  {
    path: '/umycode/systeach/:codeID',
    name: 'systeach',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/ucode.vue')
  },
  {
    path: '/umycode/user/:codeID',
    name: 'user',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/ucode.vue')
  },
  {
    path: '/umycode/teach/:codeID',
    name: 'teach',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/ucode.vue')
  },
  {
    path: '/umycode/system/:codeID',
    name: 'system',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/ucode.vue')
  },


  {
    path: '/mycode/systeach/:codeID',
    name: 'systeach',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },
  {
    path: '/mycode/user/:codeID',
    name: 'user',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },
  {
    path: '/mycode/teach/:codeID',
    name: 'teach',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },
  {
    path: '/mycode/system/:codeID',
    name: 'system',
    meta: { title: "我的代码" },
    component: () => import('@/views/pages/admin/code.vue')
  },
  {
    path: '/usercode/:userID/:contestID/:chapterID/:sectionID',
    name: 'user',
    meta: { title: "用户代码" },
    component: () => import('@/views/base/user_code.vue')
  },
  {
    path: '/teach/:userID/:contestID/:chapterID/:sectionID',
    name: 'teach',
    meta: { title: "用户代码" },
    component: () => import('@/views/base/user_code.vue')
  }
]
